<template>
</template>

<script>
import { waitForFonts } from "./waitForFonts.js";

export default {
  name: "SiennaAccessibility",

  props: {
    fonts: {
      type: Array,
    },
  },

  data() {
    return {
      lib: null,
    };
  },

  async mounted() {
    try {
      if (this.fonts) {
        const loadedNames = await waitForFonts(this.fonts);
      }

      const module = await import('sienna-accessibility');
      this.lib = module.default;
    } catch (err) {
      console.error(err.message);
    }
  },
};
</script>

<style lang="scss">
.asw-widget .asw-menu-btn {
  bottom: 90px !important;
  --asw-btn-size: 58px;
  --asw-icon-size: 26px;
  left: unset !important;
  right: 20px;
}

.asw-menu {
  left: unset !important;
  right: 0 !important;
}

@media screen and (min-width: 768px) {
  .asw-widget .asw-menu-btn {
    width: 42px !important;
    height: 42px !important;
  }

  .asw-menu-btn svg {
    width: 26px !important;
    height: 26px !important;
    min-height: 26px !important;
    min-width: 26px !important;
    max-width: 26px !important;
    max-height: 26px !important;
  }
}

@media screen and (min-width: 992px) {
  .asw-widget .asw-menu-btn {
    bottom: 15px !important;
  }
}
</style>